import styled from 'styled-components'

import ContentBox from '../../components/ContentBox'
import BackLink from '../../components/BackLink'
import ConfirmationForm from '../../components/forms/ConfirmationForm'
import AuthenticationIntro from '../../components/AuthenticationIntro'

export const Content = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`

export const ContentBoxC = styled(ContentBox)`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const Back = styled(BackLink)`
  margin-right: auto;
`

export const Form = styled(ConfirmationForm)`
  margin-top: 36px;
`

export const Intro = styled(AuthenticationIntro)`
  margin-top: 36px;
`
